import { default as WidgetTrustpilotComponent } from '@components/WidgetTrustpilot';
import { RichText } from 'prismic-reactjs';
import ColoredSlice from '@monofront/design-system/organisms/ColoredSlice';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import CustomPrismicHeading from '@components/CustomPrismicHeading';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapWidgetTrustpilot } from './mapWidgetTrustpilot';
import { IWidgetTrustpilotProps } from './types';

const WidgetTrustpilot: React.FC<IWidgetTrustpilotProps> = ({
  backgroundColor,
  height,
  stars,
  templateid,
  theme,
  title,
  titleDecoration,
  width,
}) => {
  return (
    <>
      <ColoredSlice
        title={
          <RichText
            render={title}
            htmlSerializer={CustomPrismicHeading({
              className: 'catchy-title title',
              after:
                titleDecoration.url &&
                titleDecoration.dimensions?.width &&
                titleDecoration.dimensions.height ? (
                  <span className="title-icon">
                    <ResponsiveImage
                      src={titleDecoration.url}
                      alt={titleDecoration.alt}
                      width={titleDecoration.dimensions?.width}
                      height={titleDecoration.dimensions?.height}
                    />
                  </span>
                ) : undefined,
            })}
          />
        }
        backgroundColor={backgroundColor}
        content={
          <div className="widget">
            <WidgetTrustpilotComponent
              templateId={templateid}
              height={height}
              width={width}
              theme={theme}
              stars={stars}
            />
          </div>
        }
      />
      <style jsx>{`
        .widget {
          width: ${width};
          max-width: 1000px;
          min-width: 300px;
        }
      `}</style>
    </>
  );
};

export default withSlice(WidgetTrustpilot, mapWidgetTrustpilot);
